import { render, staticRenderFns } from "./AssociateUserDialog.vue?vue&type=template&id=37d9cb37&"
import script from "./AssociateUserDialog.vue?vue&type=script&lang=js&"
export * from "./AssociateUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AssociateUserDialog.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./AssociateUserDialog.vue?vue&type=custom&index=1&blockType=i18n&lang=yaml&locale=dk"
if (typeof block1 === 'function') block1(component)

export default component.exports